export const TERMS_EN = {
  title: "Terms & Conditions",
  version: "1.0",
  updated: "2026-06-01",
  intro:
    "These Terms govern your use of the HELCOO attendance platform (the “Service”), on the web and in our mobile apps. By creating an account or using the Service you accept these Terms in full. If you accept on behalf of a company, you confirm you are authorised to do so.",
  sections: [
    {
      h: "1. Definitions",
      p: ["“We”/“Operator” means the owner of the HELCOO platform. “Customer” means the subscribing company. “End User” means a Customer employee who records attendance. “Content” means data uploaded by the Customer or its users."],
    },
    {
      h: "2. The Service",
      p: ["The Service records check-in/check-out with face verification and liveness detection, validates the user's location against branch geofences, and manages shifts, leave, payroll and reports. We may improve or change features, with prior notice of material changes."],
    },
    {
      h: "3. Accounts and eligibility",
      p: ["Users must be 18 or older, or 16 with employer and guardian consent where local law permits. You are responsible for keeping credentials confidential and for all activity under your account, and must notify us promptly of any suspected unauthorised access."],
    },
    {
      h: "4. Biometric data (face template) — explicit consent",
      p: [
        "Attendance verification requires processing a live face image and creating a digital face template used only for matching. This data is never used for marketing or advertising, never used to identify a person outside attendance verification, and is never sold or shared with third parties for commercial purposes.",
        "The Customer is responsible for obtaining explicit, informed and written consent from each employee before enrolling their face, as required by applicable law. Any user may withdraw consent by contacting their employer or support@helcoo.uk; the face template is then deleted and face verification is disabled for that account.",
      ],
    },
    {
      h: "5. Location data",
      p: ["Location coordinates are captured only at the moment a user initiates a check-in or check-out, solely to confirm presence inside the branch geofence. We do not perform background or continuous location tracking."],
    },
    {
      h: "6. Data protection roles",
      p: ["The Customer is the data controller for its employees' data; we act as processor, processing data only on the Customer's instructions and to operate the Service."],
    },
    {
      id: "billing",
      h: "7. Subscription and billing (business contract)",
      p: [
        "This clause concerns the Customer company only, under the business contract; it does not apply to employees using the app. The iOS and Android apps are entirely free and contain no purchase or payment of any kind.",
        "A subscription to the Service is a business contract between HELCOO and the employing company (the \"Customer\"), concluded and managed outside the app stores. Service starts with a free trial on approval; fees are then set according to the plan and the number of active employees, and the subscription continues into the next billing period unless the Customer cancels before it begins.",
        "Billing, refunds and cancellation are governed solely by that business contract and are not subject to any app store's billing policies. Fees are non-refundable except where required by law or provided for in the contract.",
        "The iOS and Android apps are entirely free and contain no in-app purchase, no prices and no subscription buttons. The employee (end user) never pays us anything and is never asked for payment details. On termination the Customer is given 30 days to export its data.",
      ],
    },
    {
      h: "8. Acceptable use",
      p: ["You must not spoof attendance (photos, masks, location manipulation), attempt unauthorised access, reverse engineer the Service, resell it, or upload unlawful or infringing content."],
    },
    {
      h: "9. Intellectual property",
      p: ["All intellectual property in the software, design and brand remains ours. Customer Content remains the Customer's, who grants us a limited licence to process it solely to operate the Service."],
    },
    {
      h: "10. Disclaimers and liability",
      p: ["The Service is provided “as is” without warranty that any automated verification is infallible. We are not liable for indirect damages, lost profits or lost data, and our total liability is limited to amounts paid in the twelve months preceding the claim."],
    },
    {
      h: "11. Termination and data deletion",
      p: ["Either party may terminate under these Terms. On termination the Customer may export data for 30 days, after which data is permanently deleted; face templates are deleted immediately. To request account and data deletion, email support@helcoo.uk."],
    },
    {
      h: "12. Changes to these Terms",
      p: ["We may update these Terms and will notify users of material changes before they take effect. Continued use after the effective date means you accept the updated version."],
    },
    {
      h: "13. Governing law and contact",
      p: ["These Terms are governed by the laws of the United Kingdom, without prejudice to mandatory consumer rights in your country of residence. Legal enquiries: support@helcoo.uk."],
    },
  ],
};
